import React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { actions, selectors } from '@cinch/oxd-redux/lifestyle/src'
import { actions as profileActions, selectors as profileSelectors } from '@cinch/oxd-redux/profile/src'
import { RecommendationsService } from '@cinch/oxd-utils/requests/src'

import LifestyleComponent, { LifestyleComponentProps } from './lifestyle.component'
import { navigateToLifestyleStage } from './utils'

import { LifestyleData, LifestyleDomainReducer } from '@cinch/oxd-redux/lifestyle/src/reducers/domain'
import { ProfileReducer } from '@cinch/oxd-redux/profile/src/reducers/domain'

interface ReduxState {
  lifestyle: LifestyleDomainReducer
  profile: ProfileReducer
  [key: string]: any
}

interface PropsFromRedux {
  initialValues: LifestyleData
  isPending: boolean
}

interface PropsFromDispatch {
  onPageNext: (values: any, currentPage: number) => void
  goToPage: (pageNumber: number) => void
}

interface ReduxProps extends PropsFromRedux, PropsFromDispatch {}

type OwnProps = Pick<LifestyleComponentProps, Exclude<keyof LifestyleComponentProps, keyof ReduxProps>>

export const mapStateToProps = (state: ReduxState): PropsFromRedux => {
  const isPending =
    selectors.getPredicate(state).isPending || profileSelectors.getPredicate(state).fetchStatus.isPending
  const initialFormValues = selectors.getLifestyleData(state)

  return { isPending, initialValues: initialFormValues }
}

export const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  goToPage: (pageNumber: number) => navigateToLifestyleStage(pageNumber),
  onPageNext: (data: RecommendationsService.RecommendationRequest, currentPage: number) => {
    const { budget, finance, partExchange, ...lifestyleData } = data
    const currentPageIsBudgetScreen = currentPage === 1

    if (currentPageIsBudgetScreen) {
      dispatch(profileActions.updateProfile({ budget, finance, partExchange }))
      navigateToLifestyleStage(currentPage + 1)
    } else {
      dispatch(actions.updateLifestyle({ currentPage, data: lifestyleData }))
    }
  },
})

const MemoisedLifestyleComponent = React.memo(LifestyleComponent)

export default connect<PropsFromRedux, PropsFromDispatch, OwnProps, ReduxState>(
  mapStateToProps,
  mapDispatchToProps,
)(({ initialValues, ...props }: ReduxProps & OwnProps) => {
  const [initialFormValues] = useState(initialValues)

  return <MemoisedLifestyleComponent {...props} initialValues={initialFormValues} />
})
